import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollTopNow } from '../utils/scroll';

const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        scrollTopNow();
    }, [pathname]);

    return null;
};

export default ScrollToTop;
